export default function auditLogApi() {
  const stage = process.env.REACT_APP_STAGE
  switch (stage) {
    case "production":
      return process.env.REACT_APP_AUDIT_LOG_API_PROD
    case "staging":
      return process.env.REACT_APP_AUDIT_LOG_API_STAGE
    case "development":
      return process.env.REACT_APP_AUDIT_LOG_API_DEV
    default:
      return process.env.REACT_APP_AUDIT_LOG_API_LOCAL
  }
}
